import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerLogService } from "../../../services/api/consumer-log.service";
import { ConsumerAchActions } from "../../actions/consumer-ach.actions";
import { ConsumerTransactionActions } from "../../actions/consumer-log.actions";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { ConsumerTransactionSelectors } from "../../selectors/consumer-transaction.selectors";

@Injectable()
export class AchStatusEffects {
	requested = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerTransactionActions.achStatus.get),
			withLatestFrom(this.store.select(ConsumerTransactionSelectors.achStatus)),
			switchMap(([action, status]) =>
				status !== undefined && !status.loading && _.has(status, "status")
					? of(ConsumerTransactionActions.achStatus.getSuccess(status))
					: of(ConsumerTransactionActions.achStatus.getApi())
			)
		)
	);

	apiRequested = createEffect(() =>
		this.actions.pipe(
			ofType(
				ConsumerTransactionActions.achStatus.getApi,
				ConsumerAchActions.accountRetrySucceeded
			),
			switchMap(() =>
				this.consumerLogService.achAccountStatus().pipe(
					map((status) =>
						ConsumerTransactionActions.achStatus.getSuccess({ status, loading: false })
					),
					catchError((error) =>
						of(ConsumerTransactionActions.achStatus.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerLogService: ConsumerLogService,
		private store: Store<AppState>
	) {}
}
